import { useNavigate } from "react-router-dom";
import Style from "../index.module.css";

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div className={Style.container}>
      <h1 className={Style.title}>403</h1>
      <p className={Style.text}>Você não tem acesso a este recurso!</p>
      <button
        className={Style.button}
        onClick={() => navigate(-1)} 
      >
        Voltar
      </button>
    </div>
  );
};

export default Forbidden;
